<template>
  <button
    type="button"
    class="
      flex w-full items-center justify-between pr-1 text-left
      md:py-0
    "
    :class="[
      open
        ? (theme === 'integrity' ? 'text-white/80' : 'text-red-500')
        : '',
      theme === 'integrity' ? 'hover:text-white/80' : 'hover:text-red-500',
    ]"
    :tabindex="parentOpen ? 0 : -1"
    @click="$emit('toggle', !open)"
  >
    <div class="w-max">
      {{ navItem.page.title }}
    </div>
    <IconArrowDown
      class="size-2.5 shrink-0 transition-transform"
      :class="open ? `-rotate-180 delay-75 duration-75 ease-in` : `
        duration-150 ease-in
      `"
    />
  </button>
  <ul
    class="mx-3 overflow-hidden duration-300 ease-out"
    :class="[
      open
        ? 'max-h-100 transition-[max-height]'
        : 'max-h-0 opacity-10 transition-all',
    ]"
  >
    <li
      v-for="(level3NavItem) in navItem.children"
      :key="level3NavItem.id"
      class="ml-1 mt-1.5 leading-tight"
    >
      <DesktopNavigationLink :to="level3NavItem.page.url" :tabindex="parentOpen && open ? 0 : -1">
        {{ level3NavItem.page.title }}
      </DesktopNavigationLink>
    </li>
  </ul>
</template>

<script setup lang="ts">
defineProps({
  navItem: {
    type: Object,
    required: true,
  },
  open: {
    type: Boolean,
    required: true,
  },
  parentOpen: {
    type: Boolean,
    required: true,
  },
})

defineEmits(['toggle'])

const theme = useTheme()
</script>
